import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IResponse} from "../../utils/interfaces/response";
import {IDrawRequest} from "../../utils/interfaces/draw.interface";

@Injectable({
  providedIn: 'root'
})
export class DrawService {

  private readonly URI_API = environment.apiConfig.uri + 'Draw';

  constructor(private readonly httpClient: HttpClient) {
  }

  deliver(params: IDrawRequest): Observable<IResponse<boolean>> {
    return this.httpClient.patch<IResponse<boolean>>(
      `${this.URI_API}/deliver/${params.drawId}/${params.winnerName}`, {}
    );
  }
}
